// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Isolation Units API
 * Manage isolation units, clusters and partitions.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Partition } from './Partition';
import {
  PartitionFromJSON,
  PartitionFromJSONTyped,
  PartitionToJSON,
  PartitionToJSONTyped,
} from './Partition';

/**
 *
 * @export
 * @interface PartitionListResponse
 */
export interface PartitionListResponse {
  /**
   *
   * @type {Array<Partition>}
   * @memberof PartitionListResponse
   */
  items?: Array<Partition>;
}

/**
 * Check if a given object implements the PartitionListResponse interface.
 */
export function instanceOfPartitionListResponse(
  value: object,
): value is PartitionListResponse {
  return true;
}

export function PartitionListResponseFromJSON(
  json: any,
): PartitionListResponse {
  return PartitionListResponseFromJSONTyped(json, false);
}

export function PartitionListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PartitionListResponse {
  if (json == null) {
    return json;
  }
  return {
    items:
      json['items'] == null
        ? undefined
        : (json['items'] as Array<any>).map(PartitionFromJSON),
  };
}

export function PartitionListResponseToJSON(json: any): PartitionListResponse {
  return PartitionListResponseToJSONTyped(json, false);
}

export function PartitionListResponseToJSONTyped(
  value?: PartitionListResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    items:
      value['items'] == null
        ? undefined
        : (value['items'] as Array<any>).map(PartitionToJSON),
  };
}
